import type { SVGProps } from 'react';
const SvgAngleRight = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path d="M15.234 12.5311L10.9853 16.7798C10.6917 17.0734 10.2168 17.0734 9.92627 16.7798L9.22024 16.0737C8.92659 15.7801 8.92659 15.3052 9.22024 15.0147L12.2318 12.0031L9.22024 8.99156C8.92659 8.69791 8.92659 8.22306 9.22024 7.93252L9.92315 7.22024C10.2168 6.92659 10.6917 6.92659 10.9822 7.22024L15.2309 11.4689C15.5276 11.7626 15.5276 12.2374 15.234 12.5311V12.5311Z" />
  </svg>
);
export default SvgAngleRight;
